import { SentimentBadge } from "@aircall/blocks";
import { Tooltip, TooltipContent, TooltipTrigger } from "@aircall/ds";
import { Info } from "@aircall/react-icons";
import { useTranslation } from "react-i18next";
import { Feedbacks } from "@/blocks/Feedbacks/Feedbacks";
import { Section } from "@/blocks/Section/Section";
import { Link } from "@/components/Link/Link";
import { SentimentType, SentimentValue } from "@/graphql/generated/graphql";
import { useCall } from "@/hooks/useCall/useCall";
import { useSectionSentiment } from "./SectionSentiment.hooks";

function toBadgeSentiment(
  sentiment: SentimentValue
): "positive" | "negative" | "neutral" {
  switch (sentiment) {
    case "POSITIVE":
      return "positive";
    case "NEGATIVE":
      return "negative";
    default:
      return "neutral";
  }
}

export function SectionSentiment() {
  const { t } = useTranslation();

  const { call } = useCall();
  const sentiment = call?.overallSentiments?.get(SentimentType.EXTERNAL);

  const {
    onClickThumbUp: handleOnClickThumbUp,
    onClickThumbUpUpdated: handleOnClickThumbUpUpdated,
    onClickThumbDown: handleOnClickThumbDown,
    onClickThumbDownUpdated: handleOnClickThumbDownUpdated,
  } = useSectionSentiment();

  if (!sentiment) {
    return null;
  }

  return (
    <Section data-test="customer-mood-card">
      <div className="flex items-center gap-1">
        <span className="text-sm font-semibold">
          {t("customer_mood.title")}
        </span>
        <Tooltip>
          <TooltipTrigger render={<div data-test="customer-mood-info" />}>
            <Info className="size-4" />
          </TooltipTrigger>
          <TooltipContent side="top" align="center">
            {t("customer_mood.tooltip.content")}{" "}
            <Link href={t("customer_mood.tooltip.href_url")} target="_blank">
              {t("customer_mood.tooltip.href_title")}
            </Link>
          </TooltipContent>
        </Tooltip>
      </div>
      <div className="flex items-center gap-4">
        <SentimentBadge sentiment={toBadgeSentiment(sentiment)} />
        <Feedbacks
          onClickThumbUp={handleOnClickThumbUp}
          onClickThumbDown={handleOnClickThumbDown}
          onClickThumbUpUpdated={handleOnClickThumbUpUpdated}
          onClickThumbDownUpdated={handleOnClickThumbDownUpdated}
        />
      </div>
    </Section>
  );
}
